export const authUrl =
  "https://developer.api.autodesk.com/authentication/v1/authenticate";

export const authClientId = "ELodJDfTxph2KRRqDDyAYxrsw159C5lZ";
export const authClientSecret = "juLsn872v7R8nfGQ";
export const versionsUrl =
  "https://developer.api.autodesk.com/data/v1/projects/:project_id/items/:item_id/versions";

export const revitStandardsProjectId = "b.67db14fd-3464-4e43-be30-e83936bddf36";
